declare var $: any;

import { Autosave } from "../modules/autosave";
import { Navigation } from "../partials/navigation";
import { Spinner } from "../modules/spinner";

export class ProductionCalculation {
    static init() {
        $(Autosave.containerPageClass).on("reloadedBeforeFocus", ProductionCalculation.update);
        $(".js-houses-form").on("reloaded", Autosave.triggerInstantSave);
        ProductionCalculation.update();
        ProductionCalculation.disableFieldsHavingCalculatedDefaultValues();
        $("form").on("submit", ProductionCalculation.disableButtonAfterSubmission);
    }

    static disableButtonAfterSubmission(e: Event) {
        $(e.target).find("button[type=submit]").prop('disabled', true);
        return true;
    }

    static saveCostGroupStates() {
        const values = new Array();
        $(".cost-group").each(function () {
            values.push($(this).hasClass("open") ? "1" : "0");
        });
        $("input[name=costGroupStates]").val(values.join(","));
    }

    static loadCostGroupStates() {
        if ($("input[name=costGroupStates]").length === 0)
            return;

        var values = $("input[name=costGroupStates]").val().split(",");
        $(".cost-group").each(function (index: number) {
            if (values[index] === "1") {
                $(this).addClass("open");
                $("div.table-blind", $(this)).show();
            }
        });
    }

    static bindNonResidentialFloorArea() {
        $("#NonResidentialFloorArea").change(ProductionCalculation.toggleHasFacilities);
    }

    static update() {
        $(".cost-group h4").click(ProductionCalculation.toggleCostGroup);
        $(".js-nav-button").click(ProductionCalculation.save);
        ProductionCalculation.bindNonResidentialFloorArea();

        ProductionCalculation.updateRowListeners();
        ProductionCalculation.loadCostGroupStates();
        ProductionCalculation.showInvalidGroups();
        ProductionCalculation.toggleHasFacilities();
    }

    static toggleHasFacilities() {
        if ($("#NonResidentialFloorArea").val() > 0) {
            $("#HasFacilities").prop("checked", true).prop("disabled", true);
        } else {
            $("#HasFacilities").prop("disabled", false);
        }
    }

    static save(e: Event) {
        e.preventDefault();
        const $button = $(this);
        Navigation.addDirectionElement($button.data("direction"), $button);
        $(Autosave.formClass).submit();
    }

    static showInvalidGroups() {
        const $el = $(".field-validation-error");
        $el.closest(".table-blind").show();
        $el.closest(".cost-group").addClass("open");
    }

    static updateRowListeners() {
        $(".add-extra-button").off().click(ProductionCalculation.addExtraRow);
        $(".remove-extra-button").off().click(ProductionCalculation.removeExtraRow);
    }

    static toggleCostGroup() {
        const div = $(this).parent("div");
        div.toggleClass("open");
        const table = div.find(".table-blind");

        if (div.hasClass("open")) {
            table.slideDown(250);
        } else {
            table.slideUp(200);
        }
        ProductionCalculation.saveCostGroupStates();
    }

    static addExtraRow(event: Event) {
        // Determine VAT type
        const isFreeOfVat = $(event.target).closest("tr").hasClass("extra--free-of-vat");

        // Copy the 'original' row
        const tr = $(event.target).closest("tr");
        const originalHtml = tr.html();

        // Update the new row with the new index
        const nextIndex = ProductionCalculation.numberOfExistingExtraRows(tr, isFreeOfVat);
        const newHtml = originalHtml.replace(/\[([0-9]+)\]/g, `[${nextIndex}]`);

        // Append the new row using the correct VAT type
        const newRow = `<tr class='${ProductionCalculation.vatClassName(isFreeOfVat)} added'>${newHtml}</tr>`;
        $(newRow).insertAfter(tr);

        ProductionCalculation.updateRowListeners();
    }

    static removeExtraRow(event: Event) {
        const tr = $(event.target).closest("tr");
        const deletetionUrl = tr.find("input[type=text]").data("delete-url");

        if (!deletetionUrl) {
            // The row has not yet been saved on the server side, so no need to call the server
            tr.remove();
            return;
        }

        const $form = $(Autosave.formClass);
        const formData = $form.serialize();

        Spinner.spin(tr);

        $.ajax({
            type: "DELETE",
            url: deletetionUrl,
            data: formData
        })
        .done((responseData: any) => {
            $(Autosave.resultsContainerClass).html(responseData);
            $(Autosave.resultsContainerClass).trigger("reloadedBeforeFocus");
            $(Autosave.resultsContainerClass).trigger("reloaded");
        }).always(() => {
            Spinner.stop(tr);
        });
    }

    static vatClassName(isFreeOfVat: boolean): string {
        return `extra--${isFreeOfVat ? "free-of-vat" : "subject-to-vat"}`;
    }

    static numberOfExistingExtraRows(tr: any, isFreeOfVat: boolean): number {
        return tr.closest("table")
            .find(`tr.${ProductionCalculation.vatClassName(isFreeOfVat)}`).length;
    }

    static disableFieldsHavingCalculatedDefaultValues() {
        $(".disableIfTemplateProject").prop("disabled", true);
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/productionCalculation.ts